// extracted by mini-css-extract-plugin
module.exports = {"cat-c-toast":"add-to-cart_cat-c-toast__amOG1"};